import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";

const BusinessOnboardLanding = Loadable(
  lazy(() =>
    import("./BusinessOnboardLanding").then((m) => ({
      default: m.BusinessOnboardLanding,
    })),
  ),
);

const BusinessOnboard = Loadable(
  lazy(() =>
    import("./BusinessOnboard").then((m) => ({ default: m.BusinessOnboard })),
  ),
);

/**
 * v2 onboarding routes. Added as children of the /auth PublicRoute group,
 * so final paths are /auth/signup-v2 (landing) and /auth/signup-v2/setup (stepper).
 */
export const BusinessOnboardRoutes = [
  { path: "signup-v2", element: <BusinessOnboardLanding /> },
  { path: "signup-v2/setup", element: <BusinessOnboard /> },
];
